<template>
  <div class="row mt-0">
    <div class="col-12 d-flex align-items-center pr-0">
      <div class="row w-100 pt-4">
        <div class="col-10 d-flex align-items-center">
          <p class="text-overline text-bold mb-0">{{ module.name }}</p>
        </div>

        <div class="col-2 d-flex justify-content-end align-items-center pr-0">
          <b-button
            v-b-toggle="'modal-' + module.id"
            :variant="module.type === 'optional' ? 'primary' : 'outline-secondary'"
            class="rounded-circle expand-button"
          >
            <b-icon :icon="this.icon" :scale="0.6"></b-icon>
          </b-button>
        </div>
      </div>
    </div>

    <div class="col-12 px-0">
      <b-collapse :id="'modal-' + module.id" v-model="visible">
        <slot />
      </b-collapse>
    </div>

    <div class="col-12">
      <hr class="m-0 mt-4" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModuleContainer",
  props: {
    module: Object,
    open: Boolean,
  },
  data() {
    return {
      visible: this.open,
    };
  },
  watch: {
    open: function (val) {
      this.visible = val;
    },
  },
  computed: {
    icon: function () {
      return this.visible ? "chevron-up" : "chevron-down";
    },
  },
};
</script>

<style scoped lang="scss">
.icon {
  width: 15px;
  height: 15px;
  max-width: 15px;
}

.expand-button {
  height: 24px;
  width: 24px;
  padding: 0;
  line-height: 0.9;
}
</style>
